export default "__VITE_ASSET__92c4c0e5__"